import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { TimelineElement, TimelineElementAttributes } from "../Components/Elements/Graphics/TimelineElement";
import { StringUtils } from "neo-common/Engine/Utils/StringUtils";

/**
 * TimelineElement is element which can create animation flow from object and setting up these elemenets based on frames.
 * TimelineElement need TimelineStyle as definition of animation.
 * Example:
 *   <TimelineElement Class="TimelineElement" Style="TimelineStyle" Loop="true" />
 *
 * @class TimelineElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class AdvancedTimelineElement extends TimelineElement {
    private startFrame: number;

    constructor() {
        super();

        this.startFrame = 0;
    }

    public updateByNode(node: Element): void {
        if (node.hasAttribute(AdvancedTimelineElementAttributes.START_FRAME)) {
            this.startFrame = this._framesArray.indexOf(
                parseInt(node.getAttribute(AdvancedTimelineElementAttributes.START_FRAME)),
            );

            if (this.startFrame == -1) {
                this.startFrame = 0;
            }
        }

        super.updateByNode(node);
    }

    /**
     * Start animate on timeline.
     * @method startAnimate
     * @return void
     */
    protected startAnimate(): void {
        this._timer.stop();
        this._frameCounter = this.startFrame;
        this.startFrame = 0;

        if (this.children != null) {
            if (this._framesArray[0] === 0) {
                this.animate();
            } else {
                this._timer.start(this._framesArray[0]);
            }
        }
    }

    clone(): AdvancedTimelineElement {
        let element: AdvancedTimelineElement = new AdvancedTimelineElement();

        element._elements = this._elements.clone();
        element.addChild(element._elements);
        element._style = this._style;
        element._framesArray = this._framesArray;
        element._loop = this._loop;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.startFrame = this.startFrame;

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

export const AdvancedTimelineElementAttributes = {
    START_FRAME: "StartFrame",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AdvancedTimelineElement.ts
 **/